"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var draft_js_1 = require("draft-js");
var theme = require("./theme.scss");
var BlockStyleControls_1 = require("./components/block-style-controls/BlockStyleControls");
var InlineStyleControls_1 = require("./components/inline-style-controls/InlineStyleControls");
var draft_convert_1 = require("draft-convert");
var ArticleEditor = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleEditor, _super);
    function ArticleEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeyCommand = function (command) {
            var editorState = _this.state.editorState;
            var newState = draft_js_1.RichUtils.handleKeyCommand(editorState, command);
            if (newState) {
                _this.onChange(newState);
                return true;
            }
            return false;
        };
        _this.editorFocus = function () {
            _this.editor.current.focus();
        };
        _this.onChange = function (editorState) {
            _this.setState({ editorState: editorState });
            var test = draft_convert_1.convertToHTML(_this.state.editorState.getCurrentContent());
            _this.props.onChangeDetail(test);
        };
        _this.onTab = function (e) {
            var maxDepth = 4;
            _this.onChange(draft_js_1.RichUtils.onTab(e, _this.state.editorState, maxDepth));
        };
        _this.toggleBlockType = function (blockType) {
            _this.onChange(draft_js_1.RichUtils.toggleBlockType(_this.state.editorState, blockType));
        };
        _this.toggleInlineStyle = function (inlineStyle) {
            _this.onChange(draft_js_1.RichUtils.toggleInlineStyle(_this.state.editorState, inlineStyle));
        };
        _this.state = { editorState: draft_js_1.EditorState.createWithContent(draft_convert_1.convertFromHTML(props.content)) };
        _this.editor = React.createRef();
        return _this;
    }
    ArticleEditor.prototype.render = function () {
        var editorState = this.state.editorState;
        return (React.createElement("div", { className: theme["RichEditor-root"] },
            React.createElement(BlockStyleControls_1.default, { editorState: editorState, onToggle: this.toggleBlockType }),
            React.createElement(InlineStyleControls_1.default, { editorState: editorState, onToggle: this.toggleInlineStyle }),
            React.createElement("div", { className: theme["RichEditor-editor"], onClick: this.editorFocus },
                React.createElement(draft_js_1.Editor, { blockStyleFn: getBlockStyle, editorState: editorState, handleKeyCommand: this.handleKeyCommand, onChange: this.onChange, onTab: this.onTab, ref: this.editor, spellCheck: true }))));
    };
    return ArticleEditor;
}(React.Component));
exports.default = ArticleEditor;
function getBlockStyle(block) {
    switch (block.getType()) {
        case "blockquote": return theme["RichEditor-blockquote"];
        case "code-block": return theme["public-DraftStyleDefault-pre"];
        default: return null;
    }
}
